export var phases = [
    {
        name: 'setup',
        stepCount: 5,
    },
    {
        name: 'test',
        stepCount: 23,
    },
    {
        name: 'result',
        stepCount: 3,
    },
];
